import React from "react";
import { ArrowRight, Calendar, Clock, Mic } from "react-feather";
import {
  formatInterviewLogDateTime,
  normalizeInterviewPercent,
} from "./utils/interviewLogCardUtils";
import { getInterviewScoreMeta } from "./utils/interviewScoreMeta";
import "./interviewLogsCardView.scss";

/** Normalized row shape for the card (maps from Redux/API interview object). */
export interface InterviewLogRow {
  id: string;
  role: string;
  interviewType: string;
  userName: string;
  date: string;
  duration: string;
  score: number | null;
}

interface InterviewLogsHistoryCardProps {
  interview: InterviewLogRow;
  onViewReport: (id: string) => void;
}

const InterviewLogsHistoryCard: React.FC<InterviewLogsHistoryCardProps> = ({
  interview,
  onViewReport,
}) => {
  const title = interview.role || interview.interviewType || "Interview";
  const subtitle = interview.userName || "—";
  const pct = normalizeInterviewPercent(interview.score);
  const meta = pct !== null ? getInterviewScoreMeta(pct) : null;

  const handleKey = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onViewReport(interview.id);
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      className="ilcv-card"
      onClick={() => onViewReport(interview.id)}
      onKeyDown={handleKey}
    >
      <div className="ilcv-card__left">
        <div className="ilcv-card__icon-wrap">
          <Mic size={20} />
        </div>
        <div className="ilcv-card__body">
          <h3 className="ilcv-card__title">{title}</h3>
          <p className="ilcv-card__subtitle">{subtitle}</p>
          <div className="ilcv-card__meta">
            <span>
              <Calendar size={12} />
              {formatInterviewLogDateTime(interview.date)}
            </span>
            {interview.duration ? (
              <span>
                <Clock size={12} />
                {interview.duration}
              </span>
            ) : null}
          </div>
        </div>
      </div>
      <div className="ilcv-card__right">
        {pct !== null && meta ? (
          <div className="ilcv-card__score-block">
            <div
              className={`ilcv-card__score-value ilcv-card__score-value--${meta.band}`}
            >
              {pct}
              <span className="ilcv-card__score-suffix">%</span>
            </div>
            <div className={`ilcv-card__badge ilcv-card__badge--${meta.band}`}>
              {meta.label}
            </div>
          </div>
        ) : (
          <div className="ilcv-card__score-block">
            <div className="ilcv-card__score-value ilcv-card__score-value--improving">
              —
            </div>
          </div>
        )}
        <button
          type="button"
          className="ilcv-card__action"
          onClick={(e) => {
            e.stopPropagation();
            onViewReport(interview.id);
          }}
        >
          View Report
          <ArrowRight size={16} />
        </button>
      </div>
    </div>
  );
};

export default InterviewLogsHistoryCard;
